export const config = {
    appId: process.env.REACT_APP_OUTLOOK_APP_ID || "" ,
    redirectUri: window.location.protocol + "//" + window.location.host,
    scopes: [
      'user.read',
      'mailboxsettings.read',
      'calendars.readwrite',
      "onlinemeetings.readwrite"
    ]
};
  